import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { combineLatest } from 'rxjs';
import { CompanyService } from 'src/app/shared/services/node-api/company.service';
import { LocalStorageService } from 'src/app/shared/services/angular-service/local-storage.service';
import { Meta, Title } from '@angular/platform-browser';

@Component({
  selector: 'app-company-details-page',
  templateUrl: './company-details-page.component.html',
  styleUrls: ['./company-details-page.component.scss'],
})
export class CompanyDetailsPageComponent implements OnInit {
  public company_name: any;
  public tab: any;
  public cin: any;
  public id: any;
  company_url: any;
  deviceType;
  isShows = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private companyService: CompanyService,
    private localStorage: LocalStorageService,
    private title: Title,
    private metaTagService: Meta
  ) {
    this.deviceType = localStorage.getItem('deviceType')
    // this.route.params.subscribe((params) => {
    //   this.company_name=decodeURIComponent(params.name);
    // });
    combineLatest(this.route.params, this.route.queryParams).subscribe(
      ([params]) => {
        this.company_name = params.name;
        this.tab = params.tab;
        // console.log("company_name", this.company_name);
        // console.log("tab", this.tab);
        this.getSeo(this.tab, this.company_name);
        this.company_url = this.company_name.toLowerCase()
        this.company_url = this.company_url.replaceAll(' ', '-')
        this.getCompanyByUrl(this.company_url);
        // if(this.company_name == )
      }
    );
  }

  getCompanyByUrl(url) {
    let request = '?companyUrl=' + url;
    this.companyService
      .getCompanyDetail(request)
      .then((data: any) => {
        if (data != null && data != undefined) {
          this.cin = data.cin;
          this.localStorage.setItem(this.company_name, this.cin);
          this.isShows = true;
        } else {
          this.router.navigateByUrl('/404');
        }
      })
      .catch((err: any) => {
        this.router.navigateByUrl('/404');
      });
  }

  // getCompanyCin() {
  //   if (this.localStorage.getItem(this.company_name)) {
  //     this.cin = this.localStorage.getItem(this.company_name);
  //   } else {
  //     let request = "?companyUrl=" + encodeURIComponent(this.company_name);
  //     this.companyService.getCompanyDetail(request)
  //       .then((data: any) => {
  //         if (data != null && data != undefined) {
  //           this.cin = data.cin;
  //           this.localStorage.setItem(this.company_name, this.cin);
  //         } else {
  //           this.router.navigateByUrl('/404');
  //         }
  //       })
  //       .catch((err: any) => {
  //         this.router.navigateByUrl('/404');
  //       });
  //   }
  // }

  ngOnInit(): void {
  }

  getSeo(tab, name) {
    function toTitleCase(text) {
      text = text.replaceAll("-", " ");
      return text.replace(/\w\S*/g, function(word) {
        return word.charAt(0).toUpperCase() + word.substr(1).toLowerCase();
      });
    }
    name = toTitleCase(name);
    let seosData = {
      compnayName: name,
    };

    if (tab === 'overview') {
      this.title.setTitle(
        `${seosData.compnayName} – Profile overview funding, Valuation , Financial, News`
      );
      this.metaTagService.updateTag({
        property: 'og:title',
        content: `${seosData.compnayName} - Profile overview funding, Valuation , Financial, News`,
      });
      this.metaTagService.updateTag({
        property: 'twitter:title',
        content: `${seosData.compnayName} - Profile overview funding, Valuation , Financial, News`,
      });
    } else if (tab === 'funding') {
      this.title.setTitle(
        `${seosData.compnayName} – Total Funding raised | Investors Information`
      );
      this.metaTagService.updateTag({
        property: 'og:title',
        content: `${seosData.compnayName} – Total Funding raised | Investors Information`,
      });
      this.metaTagService.updateTag({
        property: 'twitter:title',
        content: `${seosData.compnayName} – Total Funding raised | Investors Information`,
      });
    } else if (tab === 'financials') {
      this.title.setTitle(
        `${seosData.compnayName} – Financial Information, Revenue, Profit/Loss, Expenses`
      );
      this.metaTagService.updateTag({
        property: 'og:title',
        content: `${seosData.compnayName} – Finantial Information, Revenue, Profit/Loss, Expenses`,
      });
      this.metaTagService.updateTag({
        property: 'twitter:title',
        content: `${seosData.compnayName} – Finantial Information, Revenue, Profit/Loss, Expenses`,
      });
    } else if (tab === 'people') {
      this.title.setTitle(
        `${seosData.compnayName} – Board Members, Core members, Employees, Contact Info.`
      );
      this.metaTagService.updateTag({
        property: 'og:title',
        content: `${seosData.compnayName} - Board Members, Core members, Employees, Contact Info.`,
      });
      this.metaTagService.updateTag({
        property: 'twitter:title',
        content: `${seosData.compnayName} - Board Members, Core members, Employees, Contact Info.`,
      });
    } else if (tab === 'news') {
      this.title.setTitle(
        `${seosData.compnayName} – Latest News, Recent Updates, Activity and Events`
      );
      this.metaTagService.updateTag({
        property: 'og:title',
        content: `${seosData.compnayName} - Latest News, Recent Updates, Activity and Events`,
      });
      this.metaTagService.updateTag({
        property: 'twitter:title',
        content: `${seosData.compnayName} - Latest News, Recent Updates, Activity and Events`,
      });
    } else if (tab === 'roc') {
      this.title.setTitle(
        `${seosData.compnayName} – Download Company Documents and Statements`
      );
      this.metaTagService.updateTag({
        property: 'og:title',
        content: `${seosData.compnayName} - Download Company Documents and Statements`,
      });
      this.metaTagService.updateTag({
        property: 'twitter:title',
        content: `${seosData.compnayName} - Download Company Documents and Statements`,
      });
    }else if (tab === 'timeline') {
      this.title.setTitle(
        `${seosData.compnayName} –  Milestones and Achievements`
      );
      this.metaTagService.updateTag({
        property: 'og:title',
        content: `${seosData.compnayName} -  Milestones and Achievements`,
      });
      this.metaTagService.updateTag({
        property: 'twitter:title',
        content: `${seosData.compnayName} -  Milestones and Achievements`,
      });
    }
  }
}
